import { Component, DataSourceExecutionEvent, Label } from "@mcleod/components";
import { LogManager, ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutMobileCommMessageText } from "./autogen/AutogenLayoutMobileCommMessageText";

const log = LogManager.getLogger("lme.dispatch.mobilecomm.MobileCommMessageText");

const FIELD_TYPE_CAPTION = 'CAP';
const FIELD_TYPE_FREEFORM = 'FFM';
const FIELD_DEFINITION_DELIMITER = '\n';
const FIELD_TEXT_DELIMITER = '|';

export class McFormFieldDefinition {
    line: number;
    fieldType: string;
    text?: string;

    constructor(line: number, fieldType: string, text?: string) {
        this.line = line;
        this.fieldType = fieldType;
        this.text = text;
    }
}

export class MobileCommMessageText extends AutogenLayoutMobileCommMessageText{

    sourceMobileCommMessageAfterExecution(event: DataSourceExecutionEvent) {
        this.panelMobileCommMessageText.removeAll();
        const fieldDefinitions: McFormFieldDefinition[] = (this.isFreeform(this.activeRow)) 
            ? [this.getFreeformMessageDefinition(this.activeRow)]
            : this.getMcFormFieldDefinitions(this.activeRow);
        const componentsToAdd: Component[] = this.mapDefinitionToComponent(fieldDefinitions);
        this.panelMobileCommMessageText.addFromArray(componentsToAdd);
    }

    public isFreeform(row: ModelRow) {
        return row.get("mc_form_number", 0) == 0
    }

    public getFreeformMessageDefinition(row: ModelRow): McFormFieldDefinition {
        const messageText: string = row.get("message_text", "");
        return new McFormFieldDefinition(1, FIELD_TYPE_FREEFORM, messageText);
    }

    public getMcFormFieldDefinitions(row: ModelRow): McFormFieldDefinition[] {
        try {
            const definitionList: McFormFieldDefinition[] = this.parseMcFormDefinition(row.get("mc_form_definition",""));
            const messageTokens: string[] = row.get("message_text","").split(FIELD_TEXT_DELIMITER).map((s: string) => s.trim());
            
            //first token is expected to be empty string as form text begins with '|'
            let i = 1;// messageToken index, 
            definitionList.forEach(definition => {
                if (definition.fieldType != FIELD_TYPE_CAPTION) {
                    definition.text = messageTokens[i];
                    i++;
                }
            });

            return definitionList;
        } catch(e) {
            log.error("Error while processing Mobile Comm Message Content", e)
        }
        return null;
    }

    public parseMcFormDefinition(mcFormDefinition: string): McFormFieldDefinition[] {
        return mcFormDefinition.split(FIELD_DEFINITION_DELIMITER)
        .filter((s: string) => !StringUtil.isEmptyString(s))
        .map((definitionToken: String) => {
            //Uses unary + to convert string to number
            const lineNbr: number = +definitionToken.substring(0,2);
            const fieldType: string = definitionToken.substring(4,7);
            const text: string = (fieldType == FIELD_TYPE_CAPTION) ? definitionToken.substring(7).trim() : null;
            return new McFormFieldDefinition(lineNbr, fieldType, text);
        })
    }

    private mapDefinitionToComponent(definitionList: McFormFieldDefinition[]): Component[] {
        return definitionList.map((definition, i) => new Label({
            text: definition.text,
            rowBreak: (i + 1) < definitionList.length && definitionList[i+1].line > definition.line
        }));
    }
}
